module.exports = __webpack_public_path__ + "img/logo.579f8bd2.png";